import { render } from "./PerfData.vue?vue&type=template&id=7249d679&scoped=true&ts=true&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./PerfData.vue?vue&type=script&lang=ts"
export * from "./PerfData.vue?vue&type=script&lang=ts"

import "./PerfData.vue?vue&type=style&index=0&id=7249d679&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7249d679"]])

export default __exports__